import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
// 全局视觉主题：必须在 viewuiplus.css 之后加载
import "@/assets/style/theme.css";
import "@/assets/style/icon-customize/iconfont.css";
import store from './store';
import { Routes } from './router'
import { addDynamicRoutes, toSubjects } from '@/router/utils';
import App from './App.vue'
import Moment from 'moment'
import {MineMenu} from "@/api/menu";
import {getToken} from "@/api/cookie";

import Viewer from 'v-viewer'
// 设置 Moment 语言环境
Moment.locale('zh-cn')
const app = createApp(App)
const router = createRouter({
  history: createWebHashHistory(),
  routes: Routes
})
app.config.globalProperties.$moment = Moment

// isCurrentPublicEntry 判断当前浏览器地址是否为无需后台登录的公开页面。
const isCurrentPublicEntry = () => {
  const hashPath = window.location.hash.replace(/^#/, '')
  return hashPath.startsWith('/guide/')
}

// 初始化函数
const initializeApp = async () => {
  // 二维码落地页只依赖匿名接口，不能被后台用户初始化和登录跳转阻断。
  if (isCurrentPublicEntry() || !getToken()) {
    return
  }
  try {
    // 1. 获取当前用户
    await store.dispatch("user/fetchCurrentUser")
    // 2. 获取菜单数据
    const { data } = await MineMenu()
    const menus = data.data
    // 3. 添加动态路由
    addDynamicRoutes(router, menus, null)
    // 4. 处理菜单数据并存储
    const subjects = toSubjects(menus)
    await store.dispatch('menu/setSubjects', subjects)
    // 5. 并行获取字典数据
    await Promise.all([
      store.dispatch('dictionary/fetchDictionaries'),
      store.dispatch('dictionary/fetchDictionaryValues')
    ])
  } catch (error) {
    console.error('初始化失败:', error) // 检查路由是否可用再跳转
    if (router) {
      await router.replace('/login')
    }
    return // 终止后续挂载
  }
}

// 全局路由守卫优先放行二维码公开页，其余页面继续沿用后台登录校验。
router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    return next()
  }
  const hasToken = getToken();
  const currentUser = store.state.user.currentUser || {}
  if (hasToken) {
    if (currentUser.need_change_password && to.path !== '/change-password') {
      return next({ path: '/change-password' })
    }
    if (to.path === "/login" || to.path === "/" || to.path === "/#" || to.path === "/#/") {
      if (currentUser.need_change_password) {
        return next({ path: '/change-password' })
      }
      return next({path: "/service/home/DefaultHome"});
    }
    const matchedRoutes = router.getRoutes().filter(r => r.path === to.path)
    if (matchedRoutes.length === 0) {
      return next('/404')
    }
    return next()
  }
  if (to.path === '/login' || to.path === '/#/login') {
    return next();
  }
  return next(`/login?redirect=${to.path}`);
})

// 启动初始化并挂载应用
initializeApp().then(() => {
  app.use(store)
  app.use(router)
  app.use(ViewUIPlus)
  app.use(Viewer) // 注册Viewer插件
  app.use(mavonEditor)
  app.mount('#app')
}).catch(() => { // 初始化失败时创建降级应用
  const fallbackApp = createApp({
    template: '<div>应用初始化失败，请刷新或联系管理员</div>'
  })
  fallbackApp.mount('#app')
})
